import React from 'react';

interface ButtonIconProps {
  className?: string;
  style?: React.CSSProperties;
  size?: number;
}

export const ButtonIcon: React.FC<ButtonIconProps> = ({
  className,
  style,
  size = 16,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <rect width="20" height="12" x="2" y="6" rx="2" />
      <path d="M12 2v4" />
      <path d="M6 10h12" />
    </svg>
  );
};

